import { IsFunction } from "@pdfking/tfunc"

/**
 * Checks if value is an iterator.
 *
 * @param obj - Value to check
 * @returns True if has next method
 */
export const is_iterator = (obj: unknown): obj is Iterable<unknown> => {
  if (obj) {
    return IsFunction((obj as Iterator<unknown>).next)
  }
  return false
}
